import * as React from "react";
import { ReleaseArtist } from "../../../../../../../../common/types/release/release-artist";
import { Grid, InputLabel, Link } from "@material-ui/core";
import { Box, Avatar } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import { Add } from "@material-ui/icons";
import { Release } from "../../../../../../../../common/types/release/release";
import { AddArtistDialog } from "./add-artist-dialog";
import { inviteArtist } from "../../../../../sdk/artists";
import { ArtistSearchResult } from "../../../../../../../../services/artist/types/artist-search-result";

interface ReleaseDetailArtistsProps {
  artists: ReleaseArtist[];
  onUpdateField: <T extends keyof Release>(key: T, value: Release[T]) => void;
}

export const ReleaseDetailArtists: React.FC<ReleaseDetailArtistsProps> = (
  props
) => {
  const [showAddAristMenu, setShowAddArtistMenu] = React.useState(false);

  const removeArtist = (artistId: string) => {
    props.onUpdateField(
      "artists",
      props.artists.filter((a) => a.id !== artistId)
    );
  };

  const addArtistToRelease = (artist: ArtistSearchResult) => {
    inviteArtist({ name: artist.name, externalProfile: artist }).then(
      (simple_artist) => {
        if (
          props.artists.filter((a) => a.id === simple_artist.id).length === 0
        ) {
          props.onUpdateField("artists", [
            ...props.artists,
            { ...simple_artist, role: "main" },
          ]);
        }
      }
    );
  };

  return (
    <div>
      <Box display="flex" flexDirection="row" width="100%">
        <InputLabel style={{ fontSize: 24, fontWeight: 300 }}>
          Artists
        </InputLabel>
        <div
          style={{ marginLeft: "auto" }}
          onClick={() => setShowAddArtistMenu(true)}
        >
          <Add />
        </div>
      </Box>
      <Grid container spacing={2}>
        {props.artists.map((artist) => (
          <Grid item xs={6} md={4}>
            <Box>
              <Grid direction="row">
                <Link href={`/artists/${artist.id}`}>
                  <Avatar alt={artist.name} src={artist.avatar} />
                  <div>{artist.name}</div>
                </Link>
                {!artist.platforms?.spotify ? (
                  "[MISSING SPOTIFY ID]"
                ) : artist.platforms?.spotify === "NEW" ? (
                  "NEW SPOTIFY ID"
                ) : (
                  <Link href={artist.platforms?.spotify}>Spotify Link</Link>
                )}
              </Grid>
              <div onClick={() => removeArtist(artist.id)}>
                <Delete />
              </div>
            </Box>
          </Grid>
        ))}
      </Grid>
      <AddArtistDialog
        isOpen={showAddAristMenu}
        onClose={() => setShowAddArtistMenu(false)}
        onAddArtist={(artist) => addArtistToRelease(artist)}
      />
    </div>
  );
};
